import isObject from 'lodash/isObject';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// eslint-disable-next-line no-undef
@Inject('$scope')
class DashboardWidgetController {
  constructor() {
    this.isLoading = true;
    this.isMaintenance = false;
  }

  loadDataAsync(loadDataFunction, transformDataFunction, isEmptyPath) {
    this.isLoading = true;
    this.$scope.$applyAsync(
      loadDataFunction()
        .then((data) => {
          const checkIfEmpty = (dataToCheck) => {
            if (isObject(dataToCheck)) {
              if (isEmptyPath) return isEmpty(get(dataToCheck, isEmptyPath));
              return isEmpty(dataToCheck);
            }
            return !dataToCheck;
          };
          this.isEmpty = checkIfEmpty(data);
          this.data = !this.isEmpty && transformDataFunction ? transformDataFunction(data) : data;
        })
        .catch((error) => {
          console.error('WIDGET_LOAD_DATA', error);
          this.isMaintenance = true;
        })
        .finally(() => {
          this.isLoading = false;
        })
    );
  }
}

export default DashboardWidgetController;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/dashboard-widget-controller.js